import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-status-tag',
    templateUrl: './status-tag.component.html',
    styleUrls: ['./status-tag.component.scss'],
})
export class StatusTagComponent implements OnInit {
    @Input() variant: 'boolean' | 'currency' = 'boolean'
    @Input() value!: any
    @Input() label: string = ''
    @Input() useHint = false

    @Output() onClickHint = new EventEmitter()

    constructor() {}

    ngOnInit(): void {}

    handleHint(event: Event) {
        this.onClickHint.emit()
    }
}
